<template>
  <div>
    <div v-for="(_x,_i) in tableData" :key="_i">
      <!-- 求职数据展示是4个盒子并排，其他服务类型数据展示是3个盒子(imgbox,name,details)并排 -->
      <div class="normalbox flex" @click="clickList(_i,navAc)" v-if="navAc!=='qiuzhi'&&navAc!=='zhaopin'">

        <!-- 交友 -->
        <div class="imgbox" v-if="navAc==='jiaoyou'">
          <img :src="_x.u_logo|toimg" />
        </div>

        <div class="imgbox" v-else>
          <img :src="_x.imgUrl|toimg" />
        </div>
        
        <div class="name">

          <p class="title" :class="{'c1E9FFF':navAc==='zhaopin'}">
            <span style="color:red;" v-if="_x.vipType">[{{vipOption[_x.vipType]}}]</span>
            {{_x.u_nickName||_x.name}}
          </p>
          
          <!-- 当服务为 招聘，律师时，该部分不显示 -->
          <p class="time" v-if="navAc!=='zhaopin'&& navAc!=='lvshi'">
            <span class="contstr">更新时间：{{_x.createTime}}</span>
            <span>浏览量：{{_x.viewTime}}</span>
          </p>

          <div class="cont">
            <span class="contstr" v-for="(x,i) in showDataList" :key="i">{{x.title}}{{_x[x.shuxing]}}</span>
            <div class="star" v-if="navAc==='lvshi'">
              <el-rate :value="_x.score" disabled show-score text-color="#ff9900" :score-template="_x.score?_x.score.toString():''"></el-rate>
            </div>
          </div>

        </div>

        <div class="details" v-if="navAc!=='zhaopin'&& navAc!=='lvshi'">
          <em>查看详细 &gt;</em>
        </div>

        <!-- 律师 -->
        <div class="ACdetails" v-if="navAc==='lvshi'">
          <div class="tel"><i class="iconfont">&#xe68b;</i>{{_x.l_phone}}</div>
          <div class="btn">
            <span @click.stop.prevent="goRouter('flzx',_x)">法律咨询</span>
            <span @click.stop.prevent="goRouter('ajwt',_x)">案件委托</span>
          </div>
        </div>

      </div>
      
      <!-- 求职 招聘 -->
      <div class="qiuzhibox flex" @click="clickList(_i,navAc)" v-else>
        <div class="flex" style="align-items: flex-start;">
          <div class="imgbox">
            <img :src="(_x.u_logo||_x.imgUrl)|toimg" />
          </div>
          <div class="name">
            <p class="title c1E9FFF" v-if="navAc==='qiuzhi'">{{_x.u_nickName||_x.name}}</p>
            <p class="title c1E9FFF" v-if="navAc==='zhaopin'">
              <span style="color:red;" v-if="_x.vipType">[{{vipOption[_x.vipType]}}]</span>
              {{_x.jobName}} <span class="xinzi">{{_x.salary}}</span>
            </p>
            <div class="cont">
              <span class="contstr" v-for="(x,i) in showDataList" :key="i">{{x.title}}{{_x[x.shuxing]}}</span>
            </div>
          </div>
          <!-- 求职 -->
          <div class="moneybox" v-if="navAc==='qiuzhi'">
            <div class="money">{{_x.u_expectSalary}}</div>
            <div class="zhiwei">{{_x.u_expectJob}}</div>
          </div>
        </div>
        <!-- 求职 -->
        <div class="details" v-if="navAc==='qiuzhi'">
          <div class="look">查看简历</div>
          <div class="time">{{_x.createTime}}</div>
        </div>
        <!-- 招聘 -->
        <div class="details" style="text-align: right;" v-if="navAc==='zhaopin'">
          <p>{{_x.organizationName}}</p>
          <p class="time">{{_x.createTime}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['tableData', 'navAc', 'showDataList'],
  name: 'fuwuleft',
  data() {
    return {
      vipOption: ['','钻石VIP','铂金VIP','黄金VIP','普通VIP',],
    }
  },
  methods:{
    clickList(index,navAc) {
      this.$parent.clickData(index, navAc)
    },
    goRouter(str, data) {
      this.$router.push('/layerDetail?type=lvshi&id='+data.id+'&info='+str)
    }
  },
}
</script>

<style lang='scss' scoped>
.normalbox{
  border: 1px solid #eee;padding: 15px 200px 15px 15px;margin-bottom: 15px;
  position: relative;align-items: flex-start;transition: all .2s;
  &:hover{
    box-shadow: 0px 0px 20px #ccc;cursor: pointer;color: #1E9FFF;
    .name .title{color: #1E9FFF;}
  }
  .imgbox{width: 120px;height: 120px;}
  .imgbox img{width: 120px;height: 120px;}
  .name{
    font-size: 14px;margin-left: 20px;color: #666;
    p{margin-bottom: 5px;}
    .title{height: 42px;line-height: 42px;color: #444;font-weight: 400;display: block;font-size: 24px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-bottom: 5px;}
    span.contstr{display: inline-block;margin-bottom: 5px;padding-right: 20px;}
    span.contstr:last-of-type{display: block;}
    .gongziyaoqiu{display: inline-block;color: #E51802;font-size: 24px;margin-left: 30px;}
  }
  .details em{font-style: normal;position: absolute;right: 20px;top: 60px;border: 1px solid #eee;line-height: 38px;font-size: 14px;color: #999;display: block;border-radius: 3px;padding: 0 15px;}
  /* 服务名为 律师时 */
  .ACdetails{
    position: absolute;right: 50px;top: 50px;text-align: center;line-height: 32px;
    .tel{width: 175px;border: 1px solid #999;border-radius: 10px;margin-bottom: 10px;font-weight: 500;font-size: 20px;}
    .tel i{margin-right: 5px;}
    .btn span{display: inline-block;width: 80px;cursor: pointer;color: #fff;}
    .btn span:nth-child(1){background-color: #FF6B6B;}
    .btn span:nth-child(2){background-color: #1E9FFF;margin-left: 16px;}
    .oname{font-size: 16px;color: #666;}
    .time{color: #999;;}
  }
}

/* 服务名为求职时 */
.qiuzhibox{
  padding: 25px 0px 25px 0px;margin-bottom: 15px;position: relative;
  align-items: none;justify-content: space-between;
  border-bottom: 1px solid #eee;transition: all .2s;
  &:hover{box-shadow: 0px 0px 20px #ccc;padding-left: 15px;padding-right: 15px;cursor: pointer;}

  .imgbox{
    margin-right: 15px;height:78px;width: 78px;
    img{width: 78px;height: 78px;}
  }
  .name{
    width: 450px;max-width: 450px;
    .title{
      height: 42px;line-height: 42px;color: #444;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-bottom: 5px;font-size: 22px;
      .xinzi{color:red;margin-left: 50px;}
    }
    .cont{color: #999;}
    .cont span{display: inline-block;margin-right: 10px;}
  }
  .moneybox{
    margin-left: 30px;
    .money{line-height: 50px;color: #E30002;font-size: 24px;}
    .zhiwei{color: #1EB9FF;}
  }
  .details{
    padding-top: 10px;text-align: center;line-height: 32px;
    .look{width: 100px;height: 34px;line-height: 34px;color: #FF6B6B;border: 1px solid #FF6B6B;border-radius: 10px;}
    .time{margin-top: 5px;color: #999;font-size: 14px;}
  }
}
</style>